module.exports = __webpack_public_path__ + "c9cc95696f0c335affe12c8a7e407c1d.fbx";